import { captureUtmParams } from "../lib/utm.js";
import { addAgentSelector } from "../lib/for_programmers/agent_help_selector.js";
import { bindKeysForShortcutHelper } from "../lib/for_programmers/shortcut_help_page.js";
import { addHubCreation } from "../lib/for_programmers/hub_creation.js";
import { addPricingTable } from "../lib/for_programmers/pricing_table.js";
import { addCopyButtons } from "../lib/for_programmers/copy_buttons.js";
import { addMobileCommandPalette } from "../lib/for_programmers/mobile_command_palette.js";
captureUtmParams();
addAgentSelector();
bindKeysForShortcutHelper();
addHubCreation();
addPricingTable();
addCopyButtons();
addMobileCommandPalette();
